// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__36-6O","header":"MergedInvoice_header__2Ym86"};